import About from "@/components/About";
import Contact from "@/components/Contact";
import Hero from "@/components/Hero";
import Locations from "@/components/Locations";
import PatientInfo from "@/components/PatientInfo";
import Services from "@/components/Services";

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <PatientInfo />
      <Locations />
      <Contact />
    </>
  );
}
